import { ProductTemplateRepository } from './repositories/product-template'
import { ProductTemplateService } from './services/product-template'

const productTemplateRepository = new ProductTemplateRepository()

export const productTemplateService = new ProductTemplateService({
    productTemplateRepository,
})
